<style scoped  lang="less">
.pop-select-time {
  user-select: none;
  overflow: hidden;
  width: 505px;
  & > ul {
    clear: both;
    overflow: hidden;
    list-style: none;
    padding: 0 !important;
    & > li {
      cursor: pointer;
      padding-top: 17px;
      float: left;
      width: 16.66666666666667%;
      height: 60px;
      border: 1px solid #e5e5e5;
      margin-bottom: 0;
      & p {
        font-size: 12px;
        line-height: 1.33;
        text-align: center;
        color: #44a94b;
        margin: 0;
        line-height: 1;
        padding-bottom: 4px;
      }
    }
    & > li:nth-child(n + 2) {
      border-left: none;
    }
    & > li:nth-child(6n + 1) {
      border-left: 1px solid #e5e5e5;
    }
    & > li:nth-child(n + 7) {
      border-top: none;
    }
    & > li.disabled {
      cursor: not-allowed;
      background-color: #f8f9f9;
      & p {
        color: #999899;
      }
    }
    & > li.selected {
      background-color: #44a94b;
      & p {
        color: #fff;
      }
    }
    & > li.full {
      cursor: not-allowed;
      background-color: #00AAF3;
      & p {
        color: #fff;
      }
    }
  }
}
</style>
<template>
  <div class="pop-select-time">
    <ul>
      <li
        v-for="it in data"
        :class="{disabled:it.status=='disabled',full:it.status=='full',selected:value.indexOf(it.id)!=-1}"
        @click="it.status=='enabled'?pushOrRemove(it):void"
      >
        <p>{{it.preLabel&&it.nextLabel?renderFormat([it.preLabel,it.nextLabel]):(it.preLabel||it.nextLabel)}}</p>
        <p>{{it.label||''}}</p>
      </li>
    </ul>
    <div
      class="pop-form-item-error-msg-tip"
      v-if="validateMessage && showMessage"
    >{{ validateMessage }}</div>
  </div>
</template>
<script>
import AsyncValidator from "async-validator";
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    validateMessage: null,
    showMessage: {
      type: Boolean,
      default: true
    },
    renderFormat: {
      type: Function,
      default(label) {
        return label.join("~");
      }
    }
  },
  data() {
    return {
      validateState: "",
      selected:[]
    };
  },
  computed: {
    classes() {
      return [
        "pop-select-time",
        {
          [`pop-form-item-error`]: this.validateState == "error"
        }
      ];
    }
  },
  methods: {
    validateFn(callback) {
      if (this.rules.length) {
        var validator = new AsyncValidator({
          selectTime: this.rules
        });
        var tmp = this.value;
        validator.validate(
          { selectTime: tmp },
          { firstFields: true },
          errors => {
            this.validateMessage = errors ? errors[0].message : "";
            this.validateState = !errors ? "success" : "error";
            callback ? callback(this.validateMessage) : null;
          }
        );
      } else {
        this.validateMessage = "";
        this.validateState = "";
      }
    },
    clearSelect(){
      this.value=[];
      this.selected = [];
      this.$emit("on-select-change",this.selected);
    },
    pushOrRemove(it) {
      let index = this.value.indexOf(it.id);
      if (this.multiple) {
        index == -1 ? this.value.push(it.id) : this.value.splice(index, 1);
      } else {
        this.value = [];
        this.value.push(it.id);
      }
      this.onSelectChange(it);
      this.validateFn();
    },
    onSelectChange(it){
        let index=this.selected.findIndex(row=>row.id==it.id);
        if (this.multiple) {
             index == -1 ? this.selected.push(it) : this.selected.splice(index, 1);
        }else{
            this.selected = [];
            this.selected.push(it);
        }
        this.$emit("on-select-change",this.selected);
    },
  },
  events: {
    "on-form-reset"(field) {
      if (field) {
        this.validateMessage = "";
        this.validateState = "";
      }
      return false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// select-time.vue?61149434